import { Box, Heading, Text } from '@chakra-ui/react';
import Lottie from 'lottie-react';
import { FC } from 'react';
import PasswordChangeAnimation from '../../../assets/auth/correctTickAnimation.json';
import { useNavigate } from 'react-router-dom';
export const PasswordChanged: FC<{ isActivatingAccount?: boolean }> = ({
  isActivatingAccount,
}) => {
  const navigate = useNavigate();
  return (
    <>
      <Box textAlign="center" w='32rem' mx='auto'>
        <Box justifyContent='center'  maxW='150px' mx='auto'  >
          {/* NOTE:Check do we want to move to login page after animation? */}
          <Lottie
            animationData={PasswordChangeAnimation}
            onLoopComplete={() => {
              // navigate('/')
            }}
            loop={false}
          />
        </Box>
        <Heading as="h3" fontSize="3xl" color="custom_blue.1" mb={'3.5'}>
          {isActivatingAccount
            ? 'Account activated successfully!'
            : 'Password successfully changed!'}
        </Heading>
        <Text fontSize="md" color='custom_gray.1'>
          {isActivatingAccount
            ? 'Congratulations! Your account has been successfully activated, and you are now being logged in.'
            : 'Your password is changed successfully and you will be automatically logged in in seconds.'}
        </Text>
      </Box>
    </>
  );
};
